import React from "react";

export default function AgencyStep2Form({
  form,
  handleChange,
  handleFinalize,
  loading,
  phoneCountries,
  birthCountryRef,
  residenceRef,
  capRef,
  t,
  common,
}) {
  return (
    <form onSubmit={handleFinalize} className="agency-form agency-form-step2">
      <div className="agency-panel agency-panel-top">
        <div className="agency-grid-two">
          <div>
            <label className="agency-label">{t.firstName}</label>
            <input type="text" name="first_name" value={form.first_name} onChange={handleChange} required />
          </div>
          <div>
            <label className="agency-label">{t.lastName}</label>
            <input type="text" name="last_name" value={form.last_name} onChange={handleChange} required />
          </div>
        </div>

        <div className="agency-row">
          <label className="agency-label">Email</label>
          <input type="email" name="email" value={form.email} onChange={handleChange} required />
        </div>

        <div className="agency-row agency-phone-row">
          <label className="agency-label">{t.phone}</label>
          <div className="agency-phone-field">
            <select
              name="phone_country_code"
              value={form.phone_country_code}
              onChange={handleChange}
              className="agency-phone-country-select"
              aria-label={t.phoneCountryAria}
            >
              {phoneCountries.map((country) => (
                <option key={`${country.iso2}-${country.dialCode}`} value={country.dialCode}>
                  {country.flag} {country.iso2} {country.dialCode}
                </option>
              ))}
            </select>
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="328 2581 2222"
              className="agency-phone-input"
              required
            />
          </div>
        </div>

        <div className="agency-grid-two">
          <div>
            <label className="agency-label">{t.fiscalCode}</label>
            <input type="text" name="fiscal_code" value={form.fiscal_code} onChange={handleChange} required />
          </div>
          <div>
            <label className="agency-label">{t.gender}</label>
            <select name="gender" value={form.gender} onChange={handleChange} required>
              <option value="">{common.select}</option>
              <option value="M">{common.male}</option>
              <option value="F">{common.female}</option>
            </select>
          </div>
        </div>

        <div className="agency-grid-two">
          <div>
            <label className="agency-label">{t.birthDate}</label>
            <input type="date" name="birth_date" value={form.birth_date} onChange={handleChange} required />
          </div>
          <div>
            <label className="agency-label">{t.birthPlace}</label>
            <input
              type="text"
              name="birth_country"
              value={form.birth_country}
              onChange={handleChange}
              ref={birthCountryRef}
              placeholder={t.birthPlacePlaceholder}
              required
            />
          </div>
        </div>

        <div className="agency-grid-two">
          <div>
            <label className="agency-label">{t.residenceAddress}</label>
            <input
              type="text"
              name="residence"
              value={form.residence}
              onChange={handleChange}
              ref={residenceRef}
              placeholder={t.residencePlaceholder}
              required
            />
          </div>
          <div>
            <label className="agency-label">CAP</label>
            <input
              type="text"
              name="cap"
              value={form.cap}
              onChange={handleChange}
              ref={capRef}
              placeholder={t.capPlaceholder}
              required
            />
          </div>
        </div>
      </div>

      <div className="agency-panel agency-panel-bottom agency-panel-bottom-step2">
        <div className="agency-question">
          ☔ {t.rainConfirmQuestion}
        </div>

        <label className="agency-checkline">
          <input
            type="checkbox"
            name="confirm_rain_protection"
            checked={form.confirm_rain_protection}
            onChange={handleChange}
            required
          />
          <span>{t.confirmIntent}</span>
        </label>

        <label className="agency-checkline">
          <input
            type="checkbox"
            name="confirm_data_truth"
            checked={form.confirm_data_truth}
            onChange={handleChange}
            required
          />
          <span>{t.confirmTruth}</span>
        </label>

        <label className="agency-checkline">
          <input
            type="checkbox"
            name="confirm_privacy"
            checked={form.confirm_privacy}
            onChange={handleChange}
            required
          />
          <span>
            {t.privacyAcceptBefore}{" "}
            <a
              href="https://wedly.it/wp-content/uploads/2025/07/WEDLY_informativa-protezione-dati-2.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.privacyLink}
            </a>
            .
          </span>
        </label>

        <button type="submit" className="agency-btn agency-btn-submit" disabled={loading}>
          {loading ? t.submitLoading : t.submit}
        </button>
      </div>
    </form>
  );
}
